module.exports = __webpack_public_path__ + "img/goods09.e2b42882.jpg";